export default "__VITE_ASSET__3d6faeb0__"